export default {
  // 页面权限设置
  setPower: function (that) {
    const userMenus = that.$store.state.userMenus
    let power = []
    for (let i = 0; i < userMenus.length; i++) {
      if (userMenus[i].IsLeaf === '1') {
        if (userMenus[i].MenuCode.toUpperCase() === that.menuCode.toUpperCase()) {
          power = userMenus[i].power
          break
        }
      } else {
        for (let j = 0; j < userMenus[i].Children.length; j++) {
          if (userMenus[i].Children[j].MenuCode.toUpperCase() === that.menuCode.toUpperCase()) {
            power = userMenus[i].Children[j].power
            break
          }
        }
        if (power.length > 0) {
          break
        }
      }
    }

    for (let i = 0; i < power.length; i++) {
      that['show' + power[i].PowerCode.substr(0, 1).toUpperCase() + power[i].PowerCode.substr(1)] = true
    }
  }
}
